import React from "react";
import {LangContext} from "./LangContext";

export const useLang = () => React.useContext(LangContext)
